const STATUS = {
  ERROR: -1,
  SAVED: 0,
  SAVING: 1,
};

// TODO: Currently only support 1 activity at a time
const networkActivity = {
  namespaced: true,
  state: {
    status: STATUS.SAVED,
    STATUS: Object.freeze(STATUS),
  },
  getters: {},
  mutations: {
    success(state) { state.status = STATUS.SAVED; },
    error(state) { state.status = STATUS.ERROR; },
    loading(state) { state.status = STATUS.SAVING; },
    updateStatus(state, status) {
      state.status = status;
    },
  },
  actions: {
  },
};

export default networkActivity;



// WEBPACK FOOTER //
// ./src/store/modules/networkActivity.js